'use client';

import { useCallback } from 'react';

import Button from '@wconcept/wconcept-ui/components/atoms/Button';
import { IconClose2 } from '@wconcept/wconcept-ui/components/atoms/svg';
import Text from '@wconcept/wconcept-ui/components/atoms/Text';

import * as S from './style';

interface IProps {
  onSubmit?: () => void;
  onClose?: () => void;
  value: {
    title?: string;
    text: string;
    children?: React.ReactNode;
    btnType?: 'single' | 'double' | string;
    submitText?: string;
    closeText?: string;
    isIPhoneXApp: boolean;
    isDesktop: boolean;
  };
}

const NoticeModal = ({ onSubmit, onClose, value }: IProps) => {
  const {
    title,
    text,
    children,
    btnType = 'single',
    submitText = '동의',
    closeText = '미동의',
    isIPhoneXApp,
    isDesktop,
  } = value;

  // EVENT HANDLER : 동의
  const handleSubmit = useCallback(() => {
    if (typeof onSubmit === 'function') onSubmit();
  }, [onSubmit]);

  // EVENT HANDLER : 닫기
  const handleClose = useCallback(() => {
    if (typeof onClose === 'function') onClose();
  }, [onClose]);

  return (
    <S.NoticeModal
      className={isIPhoneXApp ? 'is-old-app-iphonex' : ''}
      $btnType={btnType}
    >
      {title && (
        <Text
          block
          className="title"
          font="semibold"
          weight={500}
          size={17}
          lineHeight={50}
        >
          {title}
        </Text>
      )}
      <S.BoxCont className="content">
        {text && (
          <Text
            block
            className="desc"
            size={16}
            lineHeight={24}
            color="#262626"
          >
            {text}
          </Text>
        )}
        {children && <div className="content-item">{children}</div>}
      </S.BoxCont>
      <S.BtnBox className={`area-btn ${btnType}`}>
        {btnType !== 'single' && (
          <Button className="btn-close" onClick={handleClose}>
            {closeText}
          </Button>
        )}
        <Button className="btn-submit" onClick={handleSubmit}>
          {submitText}
        </Button>
      </S.BtnBox>
      {isDesktop && (
        <Button className="btn-close" onClick={handleClose}>
          <IconClose2 />
        </Button>
      )}
    </S.NoticeModal>
  );
};

export default NoticeModal;
